module.exports = __webpack_public_path__ + "img/Judith_Icon.8f45296f.png";